import { render, staticRenderFns } from "./ProductGuaranteed.vue?vue&type=template&id=f934919a&scoped=true&"
import script from "./ProductGuaranteed.vue?vue&type=script&lang=js&"
export * from "./ProductGuaranteed.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f934919a",
  null
  
)

export default component.exports